import styled from 'styled-components';

export const AccountContentContainer = styled.div`
  width: 100%;
`;
